import React from 'react';
import { Navigate } from 'react-router-dom';

import { usePermissions } from '../../hooks/use-permissions';

function SmartRedirect() {
  const { hasPermission, hasAnyRole } = usePermissions();

  const redirectOptions = [
    { path: '/companies', permissions: ['crud companies'] },
    { path: '/users', permissions: ['crud users'] },
    { path: '/photos', permissions: ['crud photo'] },
    { path: '/albums', permissions: ['crud photo'] },
    { path: '/reports/user-content', permissions: ['crud reports'] },
    { path: '/reports/logs', permissions: ['view activity log'] },
    { path: '/badges', roles: ['contentmanager', 'admin'] },
  ];

  const redirectPath =
    redirectOptions.find((option) => {
      if (option.permissions) {
        return option.permissions.every((permission) => hasPermission(permission));
      }

      if (option.roles) {
        return hasAnyRole(option.roles);
      }

      return false;
    })?.path || '/access-denied';

  return <Navigate to={redirectPath} replace />;
}

SmartRedirect.defaultProps = {};

export default SmartRedirect;
